module.exports = __webpack_public_path__ + "img/BS03.9b0e5827.svg";